/**
 * Checkout-active route allowlist for shopping-session lifecycle (leave-zone wipe).
 *
 * Session stays through personalize ↔ `/checkout`; cleared when leaving that set
 * (success, home, start, browse, etc.).
 *
 * @see `doc/spec/SPEC_shopping_session_lifecycle.md` § Route zones
 */

/** True when the path may keep an in-memory shopping session (personalize or `/checkout`). */
export function isCheckoutActivePath(path: string): boolean {
    if (!path) {
        return false
    }
    return (
        path.startsWith('/handwritten-note/personalize/') ||
        path.startsWith('/designer/personalize/') ||
        path === '/checkout' ||
        path.startsWith('/checkout/')
    )
}
